<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <navMenu :active="active"></navMenu>
      <div class="content" v-loading.lock="loading">
        <div class="go-back" @click="goBack" style="margin-bottom: 20px">
          {{ language === "cn" ? "返回" : "Back" }}
        </div>
        <div class="header-wrap">
          <div class="main-title">
            {{ language === "cn" ? "询盘列表" : "Inquiry List" }}
          </div>
          <div class="live-search">
            <div class="search-item">
              <p>{{ language === "cn" ? "公司名称" : "Company Name" }}</p>
              <el-input
                v-model="search.companyName"
                :placeholder="language === 'cn' ? '请输入' : 'Please enter'"
              ></el-input>
            </div>
            <div class="search-item">
              <p>{{ language === "cn" ? "产品名称" : "Product Name" }}</p>
              <el-input
                v-model="search.productName"
                :placeholder="language === 'cn' ? '请输入' : 'Please enter'"
              ></el-input>
            </div>
            <div class="search-item">
              <p>
                {{ language === "cn" ? "询盘用户名称" : "Inquiry User Name" }}
              </p>
              <el-input
                v-model="search.userName"
                :placeholder="language === 'cn' ? '请输入' : 'Please enter'"
              ></el-input>
            </div>
            <div class="search-item">
              <p>
                {{
                  language === "cn"
                    ? "询盘用户手机"
                    : "Inquiry User Mobile Number"
                }}
              </p>
              <el-input
                v-model="search.mobile"
                :placeholder="language === 'cn' ? '请输入' : 'Please enter'"
              ></el-input>
            </div>
            <!-- <div class="search-item">
              <p>添加时间</p>
              <el-date-picker
                v-model="dateValue"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="changeDate"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </div> -->
            <div class="search-item">
              <p>{{ language === "cn" ? "询盘内容" : "Inquiry Content" }}</p>
              <el-input
                v-model="search.content"
                :placeholder="language === 'cn' ? '请输入' : 'Please enter'"
              ></el-input>
            </div>
            <div class="search-item" style="display: flex">
              <div class="search-btn" @click="searchHandle">
                {{ language === "cn" ? "搜索" : "Search" }}
              </div>
              <!-- <div
                class="search-btn"
                :class="{ 'search-opacity': tableData.length == 0 }"
                @click="tableData.length > 0 ? exportHandle() : ''"
                style="margin-left: 10px"
              >
                导出
              </div> -->
            </div>
          </div>
        </div>
        <div class="seek-tips" v-if="language === 'cn'">
          共有<span>{{ totals }}</span
          >条询盘，<span>{{ unReadNum }}</span
          >条新的询盘
        </div>
        <div class="seek-tips" v-if="language === 'en'">
          There are <span>{{ totals }}</span> inquiries in total, with
          <span>{{ unReadNum }}</span> new ones.
        </div>
        <div class="seek-list">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            height="400"
            :row-class-name="tableRowClassName"
            :empty-text="language === 'cn' ? '暂无数据' : 'No Records Found'"
          >
            <el-table-column
              label="ID"
              prop="id"
              min-width="50"
            ></el-table-column>
            <el-table-column
              :label="language === 'cn' ? '询盘产品' : 'inquiry product'"
              :prop="tableDataProp.product_name"
              min-width="130"
            ></el-table-column>
            <el-table-column
              :label="language === 'cn' ? '询盘用户' : 'inquiry user'"
              prop="nickname"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="language === 'cn' ? '询盘公司' : 'inquiry company'"
              prop="company_name"
              min-width="100"
            ></el-table-column>
            <el-table-column
              :label="
                language === 'cn'
                  ? '询盘用户手机号'
                  : 'inquiry user mobile number'
              "
              prop="mobile"
              min-width="120"
            ></el-table-column>
            <!-- <el-table-column
              label="咨询类型"
              prop="seek_type"
              min-width="80"
            ></el-table-column>
            <el-table-column
              label="代理省市"
              prop="agent_province"
              min-width="80"
            ></el-table-column>
            <el-table-column
              label="渠道"
              prop="channel"
              min-width="100"
            ></el-table-column>
            <el-table-column
              label="团队规模"
              prop="team_scale"
              min-width="80"
            ></el-table-column> -->
            <!-- <el-table-column label="状态" min-width="80">
              <template slot-scope="scope">
                {{
                  scope.row.status == 1
                    ? "已申请"
                    : scope.row.status == 2
                    ? "已通过"
                    : "已拒绝"
                }}
              </template></el-table-column
            > -->
            <el-table-column
              :label="language === 'cn' ? '询盘时间' : 'inquiry time'"
              prop="create_time"
              min-width="180"
            ></el-table-column>
            <el-table-column
              :label="language === 'cn' ? '询盘内容' : 'inquiry content'"
              min-width="180"
            >
              <template slot-scope="scope">
                <div class="inquiryContent">{{ scope.row.content }}</div>
              </template>
            </el-table-column>
            <el-table-column
              :label="language === 'cn' ? '操作' : 'actions'"
              width="150"
              fixed="right"
              align="center"
            >
              <template slot-scope="scope">
                <span class="check-btn" @click="edit(scope.row)">{{
                  language === "cn" ? "查看" : "view"
                }}</span>
                <span class="check-btn" @click="deleteInquiry(scope.row)">{{
                  language === "cn" ? "删除" : "delete"
                }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          background
          v-if="totals > 0"
          class="main-page"
          layout="prev, pager, next"
          :current-page="search.page_no"
          :total="totals"
          @current-change="pageChange"
        >
        </el-pagination>
      </div>
      <!-- 询盘详情弹框 -->
      <el-dialog
        :title="language === 'cn' ? '询盘信息' : 'Inquiry information'"
        :visible.sync="isShowDetail"
        :close-on-click-modal="false"
        width="845px"
      >
        <div class="inquiry-details">
          <div class="details-left">
            <div class="details-item">
              <div class="item-label">
                {{ language === "cn" ? "询盘产品" : "Product" }} ：
              </div>
              <div class="item-input">
                {{
                  language === "cn"
                    ? dialogData.product_name
                    : dialogData.en_product_name
                }}
              </div>
            </div>
            <div class="details-item">
              <div class="item-label">
                {{ language === "cn" ? "询盘用户" : "User" }} ：
              </div>
              <div class="item-input">
                {{ dialogData.nickname }}
              </div>
            </div>
            <div class="details-item">
              <div class="item-label">
                {{ language === "cn" ? "询盘用户手机号" : "Mobile" }} ：
              </div>
              <div class="item-input">
                {{ dialogData.mobile }}
              </div>
            </div>
            <div class="details-item">
              <div class="item-label">
                {{ language === "cn" ? "询盘用户企业" : "Company" }} ：
              </div>
              <div class="item-input">
                {{ dialogData.company_name }}
              </div>
            </div>
            <!-- <div class="details-item">
              <div class="item-label">所属展商：</div>
              <div class="item-input">{{ detailsData.member_company }}</div>
            </div> -->
            <!-- <div class="details-item">
              <div class="item-label">状态：</div>
              <div class="item-input">
                {{
                  detailsData.status == 1
                    ? "已申请"
                    : detailsData.status == 2
                    ? "已通过"
                    : "已拒绝"
                }}
              </div>
            </div> -->
            <!-- <div class="details-item">
              <div class="item-label">咨询类型：</div>
              <div class="item-input">{{ detailsData.seek_type }}</div>
            </div> -->
          </div>
          <div class="details-right">
            <!-- <div class="details-item">
              <div class="item-label">代理省市：</div>
              <div class="item-input">{{ detailsData.agent_province }}</div>
            </div>
            <div class="details-item">
              <div class="item-label">渠道：</div>
              <div class="item-input">{{ detailsData.channel }}</div>
            </div>
            <div class="details-item">
              <div class="item-label">团队规模：</div>
              <div class="item-input">{{ detailsData.team_scale }}</div>
            </div>
            <div class="details-item">
              <div class="item-label">计划采购数量：</div>
              <div class="item-input">{{ detailsData.plan }}</div>
            </div> -->
            <div class="details-item">
              <div class="item-label">
                {{ language === "cn" ? "询盘用户时间" : "Time" }} ：
              </div>
              <div class="item-input">
                {{ dialogData.create_time }}
              </div>
            </div>
            <div class="details-item">
              <div class="item-label">
                {{ language === "cn" ? "询盘内容" : "Content" }} ：
              </div>
              <div class="item-input item-content">
                {{ dialogData.content }}
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  skipOrReadStep,
  getInquiryList,
  seekSampleDetail,
  getReadNum,
  deleteInquiryDetail,
} from "@/api/api";
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
export default {
  components: { top, navMenu },
  name: "inquiryList",
  data() {
    return {
      loading: false,
      detail: {},
      dateValue: "",
      search: {
        companyName: "",
        productName: "",
        userName: "",
        mobile: "",
        start_time: "",
        end_time: "",
        content: "",
        page_no: 1,
        page_size: 10,
        productid: "",
        mark: "",
      },
      tableData: [],
      tableDataProp: {},
      totals: 0,
      isShowDetail: false,
      detailsData: {
        member: {},
      },
      lastStep: false,
      unReadNum: "0",
      dialogData: {},
      stepMenuList: [],
      detail: "",
      active: -1,
      page: "",
      mark: "",
      language: "",
    };
  },
  created() {
    this.language = localStorage.getItem("language");
    if (this.language === "cn") {
      this.tableDataProp.product_name = "product_name";
    } else if (this.language === "en") {
      this.tableDataProp.product_name = "en_product_name";
    }
  },
  mounted() {
    if (this.$route.query.id) {
      this.search.productid = this.$route.query.id;
    }
    this.getData();
    // this.getReadNumData();
  },
  watch: {},
  methods: {
    //24.9.14 根据是否已读未读状态增加背景色 dxm
    tableRowClassName({ row, rowIndex }) {
      if (row.is_read === 0) {
        return "highlight-row";
      }
      return "";
    },
    getData() {
      let that = this;
      let stepMenuList = JSON.parse(localStorage.getItem("menu"));
      this.stepMenuList = stepMenuList;
      var index = stepMenuList.findIndex(function (item) {
        return item.link_url == "/conference" && item.id == 32;
      });
      //24.9.1 判断是否为最后一步 dxm
      if (index == stepMenuList.length - 1) {
        that.lastStep = true;
      }
      that.detail = stepMenuList[index];
      that.active = index;
      this.search.mark = this.$route.query.mark;
      that.getSeekSampleList();
    },
    //获取时间区间
    changeDate(val) {
      if (val) {
        this.search.start_time = val[0];
        this.search.end_time = val[1];
      } else {
        this.search.start_time = "";
        this.search.end_time = "";
      }
      this.search.page_no = 1;
    },
    //获取询盘列表
    async getSeekSampleList() {
      this.loading = true;
      const res = await getInquiryList(
        `nickname=${this.search.userName}&company_name=${this.search.companyName}&product_name=${this.search.productName}&mobile=${this.search.mobile}&content=${this.search.content}&page_no=${this.search.page_no}&page_size=${this.search.page_size}&product_long_id=${this.search.productid}&mark=${this.search.mark}`
      );
      if (res.data.code == 1) {
        this.totals = res.data.data.count;
        this.tableData = res.data.data.lists;
      }
      this.loading = false;
    },
    //获取未查看询盘数量
    getReadNumData() {
      getReadNum()
        .then((res) => {
          if (res.data.code == 1) {
            let { data } = res.data;
            this.unReadNum = data.count;
          }
        })
        .catch((err) => {});
    },
    // 分页切换
    pageChange(val) {
      this.search.page_no = val;
      this.getSeekSampleList();
    },
    //搜索
    searchHandle() {
      this.getSeekSampleList();
    },
    //导出
    exportHandle() {
      this.$alert(`确定要导出吗？`, "", {
        confirmButtonText: "确定",
        callback: async (action) => {
          if (action == "confirm") {
            let {
              companyName,
              productName,
              mobile,
              start_time,
              end_time,
              content,
            } = this.search;
            let data = this.$qs.stringify({
              companyName,
              productName,
              mobile,
              start_time,
              end_time,
              content,
              export: 2,
            });
            this.loading = true;
            seekSampleList(data)
              .then((res) => {
                this.loading = false;
                if (res.data.code == 2) {
                  let { data } = res.data;
                  let url = data.url;
                  const link = document.createElement("a");
                  link.href = url;
                  link.setAttribute("download", "");
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                }
              })
              .catch((err) => {});
          }
        },
      });
    },
    //查看
    edit(row) {
      this.dialogData = row;
      console.log(this.dialogData);
      this.isShowDetail = true;
    },
    // 跳转下一步
    next(type) {
      if (type == "next") {
        //下一步
        if (this.detail.action == 1 || this.detail.action == 4) {
          this.toPath();
        } else {
          this.$message.warning("请完善信息!");
        }
      } else if (type == "skip") {
        //跳过
        this.skipOrReadStep(1);
      } else if (type == "known") {
        //已知悉
        this.skipOrReadStep(2);
      }
    },
    // 跳过或者已知悉
    skipOrReadStep(action) {
      let data = {
        action,
        mark: this.detail.mark,
      };
      skipOrReadStep(data)
        .then((res) => {
          if (res.data.code == 1) {
            this.$message.success(
              this.language === "cn" ? "操作成功" : "Operation successful"
            );
            //24.9.1 判断是否为最后一步,如果是最后一步,刷新页面不跳转 dxm
            if (!this.lastStep) {
              this.toPath();
            } else {
              window.location.reload();
            }
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toPath() {
      this.active = this.active + 1;
      let { link_url, id } = this.stepMenuList[this.active];
      if (link_url == "conference") {
        this.$router.push({
          path: link_url,
          query: {
            id,
          },
        });
      } else {
        this.$router.push({
          path: link_url,
        });
      }
    },
    async deleteInquiry(row) {
      const res = await deleteInquiryDetail({
        id: row.id,
      });
      if (res.data.code == 1) {
        this.$message.success("删除成功！");
        this.getSeekSampleList();
      } else {
        this.$message.error(res.data.msg);
      }
    },
    // 返回
    goBack() {
      this.$router.push({
        path: "/conference",
        query: {
          id: 32,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.inquiryContent {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.content {
  margin-bottom: 0;
  .check-btn {
    color: #3d83e9;
    cursor: pointer;
    font-weight: 500;
    margin: 0 5px;
  }
  .check-btn:hover {
    text-decoration: underline;
  }
  .check-del {
    color: #ff4d4f;
  }
}
.header-wrap {
  padding: 20px;
  border-radius: 10px;
  background: #fff;
}
.live-search {
  display: flex;
  flex-wrap: wrap;
  align-items: end;
  margin-top: 30px;

  .search-item {
    width: 30%;
    font-size: 14px;
    color: #7f8fa4;
    line-height: 22px;
    margin-right: 24px;
    margin-bottom: 10px;
    p {
      margin-bottom: 7px;
    }
    .el-select,
    .el-date-editor--daterange.el-input,
    .el-date-editor--daterange.el-input__inner,
    .el-date-editor--timerange.el-input,
    .el-date-editor--timerange.el-input__inner {
      width: 100%;
    }

    .search-btn {
      width: 103px;
      height: 38px;
      color: #fff;
      font-size: 14px;
      line-height: 38px;
      text-align: center;
      background: #fc933f;
      border-radius: 3px;
      cursor: pointer;
    }
    .search-opacity {
      cursor: no-drop;
      opacity: 0.7;
    }
  }
}
.seek-tips {
  color: #333;
  padding-top: 20px;
  text-align: right;
  span {
    color: #0091ff;
    font-weight: bold;
  }
}
.seek-list {
  display: flex;
  flex-wrap: wrap;
  background: #fff;
  border-radius: 10px;
  padding: 10px;
  margin-top: 20px;
  // min-height: calc(100vh - 590px);
}
.inquiry-details {
  display: flex;
  flex-wrap: wrap;
  > div {
    width: 50%;
    .details-item {
      display: flex;
      font-size: 14px;
      color: #0d0d0f;
      margin-bottom: 14px;
      .item-label {
        width: 120px;
        line-height: 36px;
        text-align: right;
      }
      .item-input {
        min-height: 36px;
        line-height: 20px;
        width: 60%;
        padding: 10px;
        box-sizing: border-box;
        border-radius: 3px;
        background: #f6f7f9;
      }
      .item-content {
        height: 135px;
      }
    }
  }
}
.conf-btn {
  position: absolute;
  bottom: 65px;
  left: 50%;
  transform: translateX(-50%);
  .btn {
    min-width: 148px;
    height: 40px;
    cursor: pointer;
    font-size: 19px;
    margin: 0 10px;
    font-weight: 500;
    color: #2690e6;
    line-height: 40px;
    text-align: center;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #008dff;
    &:hover {
      text-decoration: underline;
    }
  }
  .next-btn {
    color: #fff;
    background: #008dff;
  }
}
.main-page {
  width: 100%;
  padding: 10px 20px;
  text-align: right;
  box-sizing: border-box;
}
/deep/ .el-dialog {
  border-radius: 10px;
}
/deep/ .highlight-row {
  background-color: #f2f6fb;
}
@media only screen and (max-width: 767px) {
  .content {
    margin: 0;
    padding: 10px 20px 150px 20px;
    .live-search {
      margin-top: 20px;
      .search-item {
        width: 100%;
      }
    }
  }
}
</style>